import { injectable, inject } from 'inversify';
import BrandsService from './service/BrandsService';
import {
  BrandsRepositoryInterface,
  GetBrandsRequestParams,
} from '../domain/BrandsRepositoryInterface';
import { GetBrandsResponse } from './service/BrandsService.types';

@injectable()
class BrandsRepository implements BrandsRepositoryInterface {
  @inject(BrandsService) private brandsService!: BrandsService;

  async getBrands({
    subdomain,
  }: GetBrandsRequestParams): Promise<GetBrandsResponse> {
    const response = await this.brandsService.getBrands({
      origin: subdomain,
    });
    return response.data;
  }
}

export default BrandsRepository;
